import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { Add, Input, Remove } from '@mui/icons-material';
import { useLanguage } from '../../i18n/LanguageContext';
import { NodeCardShell } from './NodeCardShell';
import { NodeCardProps } from './NodeCardProps';

export const TvNodeCard: React.FC<NodeCardProps> = ({
  node, index, onToggle, onCommand, onEditOpen,
}) => {
  const { t } = useLanguage();

  const handleOn  = () => { if (node.state !== true)  onToggle(); };
  const handleOff = () => { if (node.state !== false) onToggle(); };

  return (
    <NodeCardShell node={node} index={index} onEditOpen={onEditOpen}>
      <Box display="flex" gap={1} mb={1.5}>
        <Button
          variant={node.state !== true ? 'contained' : 'outlined'}
          color={node.state === false ? 'error' : 'inherit'}
          size="small" onClick={handleOff} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.statusOff}
        </Button>
        <Button
          variant={node.state === true ? 'contained' : 'outlined'}
          color={node.state === true ? 'success' : 'inherit'}
          size="small" onClick={handleOn} disabled={node.isLoading} sx={{ flex: 1 }}
        >
          {t.statusOn}
        </Button>
      </Box>

      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Typography variant="caption" color="text.secondary" sx={{ minWidth: 56 }}>
          {t.tvVolume}
        </Typography>
        <IconButton size="small" aria-label={t.a11yDecrease(t.tvVolume)} onClick={() => onCommand('volumeDown')} disabled={node.isLoading}>
          <Remove fontSize="small" />
        </IconButton>
        <IconButton size="small" aria-label={t.a11yIncrease(t.tvVolume)} onClick={() => onCommand('volumeUp')} disabled={node.isLoading}>
          <Add fontSize="small" />
        </IconButton>
      </Box>

      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="caption" color="text.secondary" sx={{ minWidth: 56 }}>
          {t.tvChannel}
        </Typography>
        <IconButton size="small" aria-label={t.a11yDecrease(t.tvChannel)} onClick={() => onCommand('channelDown')} disabled={node.isLoading}>
          <Remove fontSize="small" />
        </IconButton>
        <IconButton size="small" aria-label={t.a11yIncrease(t.tvChannel)} onClick={() => onCommand('channelUp')} disabled={node.isLoading}>
          <Add fontSize="small" />
        </IconButton>
        <Box sx={{ flex: 1 }} />
        <IconButton size="small" aria-label={t.tvInput} onClick={() => onCommand('inputToggle')} disabled={node.isLoading}>
          <Input fontSize="small" />
        </IconButton>
        <Typography variant="caption" color="text.secondary">{t.tvInput}</Typography>
      </Box>
    </NodeCardShell>
  );
};
